/* eslint-disable react/prop-types */
import React, { FunctionComponent, ChangeEvent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledLabel, StyledTextarea, Required } from "./styles";

export interface TextAreaProps {
  name: string;
  placeholder?: string;
  value?: string;
  label?: string;
  required?: boolean;
  resize?: boolean;
  disabled?: boolean;
  maxWidth?: number;
  height?: number;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const TextArea: FunctionComponent<TextAreaProps> = ({
  name,
  placeholder,
  label,
  value,
  disabled,
  onChange,
  maxWidth,
  required,
  resize,
  height,
}) => (
  <Theme>
    {label && (
      <StyledLabel htmlFor={name} disabled={disabled}>
        {label}
        {required && <Required disabled={disabled} />}
      </StyledLabel>
    )}
    <StyledTextarea
      name={name}
      data-testid="text-input"
      maxWidth={maxWidth}
      height={height}
      id={name}
      aria-label={label}
      placeholder={placeholder}
      resize={resize}
      value={value}
      disabled={disabled}
      onChange={onChange}
    />
  </Theme>
);

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  resize: PropTypes.bool,
  maxWidth: PropTypes.number,
  height: PropTypes.number,
};

TextArea.defaultProps = {
  placeholder: null,
  value: null,
  label: null,
  disabled: null,
  required: null,
  resize: null,
  maxWidth: null,
  height: null,
};

export default TextArea;
